<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <app-ion-common-label
    [id]="idLabelNif"
    class="document-type-label1"
    labelStyle="display-rg"
    labelDescription="Qual o número NIF?"
    label="É o número de identificação fiscal e é semelhante ao CPF brasileiro. Normalmente ele fica no seu cartão de cidadão ou no seu passaporte, ao lado da fotografia."
  >
  </app-ion-common-label>

  <div class="conent-center conent-center--mrt-lg">
    <form [formGroup]="nifForm" *ngIf="nifForm" (ngSubmit)="submitForm($event)">
      <app-ion-common-input
        id=" idInputNif"
        name="nif"
        formControlName="nif"
        ngDefaultControl
        label="Qual o número NIF?"
        idLabel="nifLabel"
        placeholder="Número de Identificação Fiscal (NIF)"
        [minlength]="minLength"
        [maxLength]="maxLength"
        [type]="type"
        [fieldValue]="nif"
        [error]="error"
        [textError]="textError"
        (textChange)="nif = $event; errorMsg()"
        [disabled]="!this.edit"
      >
      </app-ion-common-input>
    </form>
  </div>
  <app-ion-common-button
    [id]="idButtonNif"
    class="hidden"
    [ngClass]="{
      hidden:
        !buttonEnable ||
        (selectedCountry?.preenchimento_obrigatorio && nif.length === 0) ||
        !allowedLengthSize()
    }"
    [attr.aria-hidden]="
      !buttonEnable ||
      (selectedCountry?.preenchimento_obrigatorio && nif.length === 0) ||
        !allowedLengthSize()
    "
    (clickButton)="clickNext()"
    label="Continuar"
  >
  </app-ion-common-button>
</ion-content>
